import axios from "axios";
import { getToken, getTokenHeader } from "../../../screen/auth/action";
import { getHomepageDataUrl } from "../Api";

export const getHomepageData = async (user_id = null) => {
  return new Promise(async (next) => {
      const token = await getToken();
      const params = user_id ? { user_id } : {}; 
      const response = await axios.get(getHomepageDataUrl(), {
        ...getTokenHeader(token),
        params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
